import instance from "../config";

// Candidatos (incluye las opciones "Votos Blanco" y "Votos Nulo")
export const getCandidatos = async () => {
  return instance.get("/candidato");
};

export const crearCandidato = async (nombre, tipo) => {
  const { data } = await instance.post("/candidato", { nombre, tipo });
  return data;
};

export const editarCandidato = async (id, nombre, tipo) => {
  const { data } = await instance.put(`/candidato?id=${id}`, { nombre, tipo });
  return data;
};

export const eliminarCandidato = async (id) => {
  const { data } = await instance.delete(`/candidato?id=${id}`);
  return data;
};
